import Toolbar from "@mui/material/Toolbar";
import AppBar from "@mui/material/AppBar";
import DfdsLogo from "../../assets/icons/DfdsLogo";
// import { BuFreightShipping, Account } from "@dfds-ui/icons/system";
// import { Railway } from "@dfds-ui/icons/logistics";
import Box from "@mui/material/Box";
import LogoBarStyle from "./LogoBarStyle";
import { styled } from "@mui/material/styles";
import * as React from "react";
import Typography from "@mui/material/Typography";
import { ReactComponent as Train } from "../../assets/svg/train.svg";
import { Grid } from "@mui/material";
// import LogoutButton from "./Logout/Logout";
import AccountMenu from "./Account/AccountMenu";

export default function LogoBar() {
  const classes = LogoBarStyle();

  const handleLogoClick = () => {
    window.location.reload();
  };

  const RowCenterGrid = styled(Grid)(({ theme }) => ({
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  }));

  const MyAccountIconBox = styled(Box)(({ theme }) => ({
    position: "absolute",
    right: "15px",
    [theme.breakpoints.down("md")]: {
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    },
  }));

  return (
    <Box className={classes.appBarContainer}>
      <Box className={classes.appBarFixedContainer} sx={{ flexGrow: 1 }}>
        <AppBar component="nav" className={classes.appBar}>
          <Toolbar className={classes.toolBar}>
            <Box className={classes.dfdsLogo} onClick={handleLogoClick}>
              <DfdsLogo />
            </Box>
            <RowCenterGrid container >
              <Typography className={classes.centerText} onClick={handleLogoClick}>
                INTERMODAL
              </Typography>
              <Train className={classes.railWayIcon} onClick={handleLogoClick}/>
            </RowCenterGrid>

            {/* <BuFreightShipping className={classes.freightShippingIcon} /> */}
            <MyAccountIconBox>
              <AccountMenu className={classes.accountIcon} />
            </MyAccountIconBox>
            {/* <LogoutButton /> */}
          </Toolbar>
        </AppBar>
      </Box>
    </Box>
  );
}
